import type { DeepRequired } from '../fixtures.types'

const generalInsuranceQuote: DeepRequired<GeneralInsuranceQuote> = {
  __typename: 'GeneralInsuranceQuote',
  quote_id: 'uinsure:UINH3090826:69206905',
  policy_reference: null,
  external_system: null,
  external_system_quote_uri: null,
  details: {
    __typename: 'GeneralInsuranceQuoteDetails',
    quote_stage: null,
    status: null,
    product_price_annual: null,
    product_price_monthly: null,
    product_tier: null,
    insurer_name: null,
    product_name: null,
    warnings: null,
    assumptions: {
      __typename: 'GeneralInsuranceQuoteAssumptionsDetails',
      is_first_time_buyer: true,
      unapproved_mortgage_application: null,
      permanently_occupied: null,
      subsidence: null,
      convictions: null,
      insurance_declines: null,
      flooding: null,
      unoccupied_sixty_days: null,
      business_purposes: null,
      number_of_adults: null,
      number_of_children: null,
      number_of_bathrooms: null,
      wall_construction: null,
      roof_construction: null,
      external_door_locks: null,
      window_locks_fitted: null,
      alarm_type: null,
      property_unoccupied: null,
      contents_items_to_specify: null,
    },
    cover_details: {
      __typename: 'GeneralInsuranceQuoteCoverDetails',
      buildings_cover_level: 0,
      contents_cover_level: 0,
      excess_buildings: 0,
      excess_contents: 0,
      accidental_damage_buildings: false,
      accidental_damage_contents: false,
      home_emergency_cover_premium: false,
      legal_expenses: null,
      personal_possessions_total_amount: null,
    },
  },
}

export default generalInsuranceQuote
